<template>
    <div>
        <Backer v-if="showbacker != false" />
        <div class="">
            <div>

                <b-overlay :show="!submit_tr_enabled" rounded="sm">
                    <b-card class="tr_div">
                        <div style="font-size: 20px;">Request Items</div>
                        <div style="display: inline-block; margin: 10px; vertical-align: top; padding: 5px;">
                            <span class="new_tr_label_box">
                                <b-card-text>
                                    <div>Location:</div>
                                    <b-form-select
                                        v-model="location_id"
                                        :options="locations" 
                                        size="sm" 
                                    ></b-form-select>
                                </b-card-text>
                            </span>

                            <span class="new_tr_label_box">
                                <b-card-text v-if="location_id != null">
                                    <div>Sublocation:</div>
                                    <b-form-select
                                        v-model="sublocation_id"
                                        :options="sublocations.filter(function(d) {return d.location_id == location_id})" 
                                        size="sm" 
                                        v-on:change="reset_request"
                                    ></b-form-select>
                                </b-card-text>
                            </span>

                            <span class="new_tr_label_box">
                                <b-card-text v-if="location_id != null && sublocation_id != null">
                                    <div>User:</div>
                                    <div><b> {{ userDetails.username }} </b></div>
                                </b-card-text>
                            </span>

                            <span class="new_tr_label_box">
                                <b-card-text v-if="location_id != null && sublocation_id != null">
                                    <div>Date/Time:</div>
                                    <div><b> {{ ts.format('LLL') }} </b></div>
                                </b-card-text>
                            </span>

                            <!-- <span class="new_tr_label_box" v-if="location_id != null && sublocation_id != null && tr_id != null">
                                <b-card-text>
                                    <div>TR #:</div>
                                    <div><b> {{ tr_id }} </b></div>
                                </b-card-text>
                            </span> -->
                        </div>

                        <div v-if="request_items.length <= 0">
                            <b-alert show variant="warning">No items added to this request.</b-alert>
                        </div>
                        <div v-else>
                          
                            <table class="ipt">
                                <thead>
                                    <tr style="background: #efefef;">
                                        <td class="ipt_tdhr">ID</td>
                                        <td class="ipt_tdhr">Product</td>
                                        <td class="ipt_tdhr">SKU</td>
                                        <td class="ipt_tdhr">Vendor</td>
                                        <td class="ipt_tdhr">Category</td>
                                        <td class="ipt_tdhr">Quantity</td>
                                        <td class="ipt_tdhr">Request Type</td>
                                        <td class="ipt_tdhr">Needed On</td>
                                        <!-- <td class="ipt_tdhr">Comment</td> -->
                                        <td class="ipt_tdhr">Action</td>
                                    </tr>
                                </thead>

                                <tbody v-for="idx in request_items.map(function(d, i) {return i})">
                                    <tr>
                                        <td class="ipt_tdr">
                                            {{ request_items[idx].item.product_id }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ request_items[idx].item.product_name }}

                                            <div style="margin-top: 10px;" >
                                                <div v-for="child, cidx in request_items[idx].item.children" style="font-size: 13px; margin-top: 3px; background: #efefef;">{{ child.sku }} X {{ child.quantity }}
                                                </div>
                                            </div>
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ request_items[idx].item.product_sku }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ request_items[idx].item.vendor }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ request_items[idx].item.category }}
                                        </td>

                                        <td class="ipt_tdr" style="width: 120px;">
                                            <b-input style="width: 100px; background: yellow;" size="sm" v-model="request_items[idx].quantity" type="number" min="1" step="1"></b-input>
                                        </td>

                                        <td class="ipt_tdr">
                                            <div style="padding: 5px;">
                                                <b-form-select
                                                    v-model="request_items[idx].item.request_type"
                                                    :options="request_types" 
                                                    size="sm" 
                                                ></b-form-select>

                                                <div style="margin-top: 10px; text-align: left;" v-if="request_items[idx].item.request_type == 'transfer_for_pickup'">
                                                    
                                                    <div style="text-align: left; display: inline-block;">
                                                        <div style="font-size: 13px;">Invoice #</div>
                                                        <div class="tr-inline">
                                                            <b-input size="sm" 
                                                            style="width: 200px;"
                                                            v-model="request_items[idx].item.invoice_id" type="text" placeholder="" ></b-input>
                                                        </div>
                                                    </div>

                                                    <div style="text-align: left; display: inline-block;">
                                                        <div style="font-size: 13px;">Pickup Date</div>
                                                        <div class="tr-inline">
                                                            <b-form-datepicker 
                                                                reset-button
                                                                style="width: 200px; font-size: 13px;"
                                                                size="sm" placeholder="Pickup Date" v-model="request_items[idx].item.pickup_date" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US">        
                                                            </b-form-datepicker>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div style="margin-top: 10px; text-align: left;" v-else-if="request_items[idx].item.request_type == 'transfer_for_delivery'">
                                                    
                                                    <div style="text-align: left; display: inline-block;">
                                                        <div style="font-size: 13px;">Invoice #</div>
                                                        <div class="tr-inline">
                                                            <b-input size="sm" 
                                                            style="width: 200px;"
                                                            v-model="request_items[idx].item.invoice_id" type="text" placeholder="" ></b-input>
                                                        </div>
                                                    </div>

                                                    <div style="text-align: left; display: inline-block;">
                                                        <div style="font-size: 13px;">Delivery Date</div>
                                                        <div class="tr-inline">
                                                            <b-form-datepicker 
                                                                reset-button
                                                                style="width: 200px;"
                                                                size="sm" placeholder="Delivery Date" v-model="request_items[idx].item.delivery_date" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US">        
                                                            </b-form-datepicker>
                                                        </div>
                                                    </div>

                                                    <div style="text-align: left; margin-top: 10px;">
                                                        <div style="font-size: 13px;">Address</div>
                                                        <b-input size="sm" v-model="request_items[idx].item.custom_address" type="text" placeholder="" ></b-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>


                                        <td class="ipt_tdr">
                                            <b-form-datepicker 
                                                reset-button
                                                style="width: 150px; font-size: 13px; margin: auto;"
                                                size="sm" placeholder="Request Date" v-model="request_items[idx].item.request_date" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US">        
                                            </b-form-datepicker>
                                        </td>

                                        <td class="ipt_tdr">
                                            <b-button size="sm" variant="outline-danger" @click="removeItem(idx)">Remove</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div style="margin: 10px; text-align: center;">
                                <b-button size="md" variant="success" @click="submitTR" :disabled="!submit_tr_enabled">Submit</b-button>
                            </div>
                        </div>
                    </b-card>
                </b-overlay>

                <!--search items-->
                <div style="margin-top: 5px;" v-show="location_id != null && sublocation_id != null">
                    <b-card>
                        <div style="font-size: 20px;"><b>Search Products To Add In Request</b></div>

                        <div style="font-size: 14px; background: #efefef; padding: 10px;">
                            <div style="margin-bottom: 10px;">
                                <b-form @submit="searchProducts">
                                    <span style="display: inline-block;">
                                        <b-form-input size="sm" required style="width: 300px;" v-model="search_keyword" placeholder="search a product / sku to add" autocomplete="off"></b-form-input>
                                    </span>
                                    <span style="display: inline-block;">
                                        <b-button size="sm" variant="success" :disabled="block_search" type="submit">Search</b-button>
                                    </span>

                                    <span style="display: inline-block;">
                                        <b-button size="sm" variant="secondary" @click="searched_products=[]; search_keyword=null;">Clear</b-button>
                                    </span>
                                </b-form>
                            </div>

                            <vue-good-table
                              v-show="searched_products.length > 0"
                              :columns="searched_products_columns"
                              @on-cell-click="onSearchedProductsColumnClick"
                              :rows="searched_products"
                              :pagination-options="{
                                enabled: false,
                                mode: 'pages',
                                position: 'top',
                                perPage: 20
                              }"
                              :search-options="{
                                enabled: false,
                                trigger: 'enter'
                              }"
                              :select-options="{ enabled: false }"
                              styleClass="vgt-table bordered condensed"
                            >
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'actions'">
                                        <span>
                                            <b-button variant="outline-success" size="sm">Add</b-button>
                                            <b-button variant="outline-primary" size="sm" style="visibility: hidden;"> </b-button>
                                        </span>
                                    </span>

                                    <span v-else-if="props.column.field == 'quantity'">
                                        <b-input size="sm" style="margin: auto; width: 100px;" v-model="searched_products[props.row.originalIndex].quantity" type="number"></b-input>
                                    </span>

                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>

                        <div style="margin-top: 30px;">
                            <div style="margin-bottom: 10px;">
                                
                                <div style="font-size: 20px;"><b>Add A Special Item In Request</b></div>
                                <div style="font-size: 14px; background: #efefef; padding: 10px;">
                                    <b-form @submit="addSpecialProduct">
                                        <div style="display: inline-block; width: 250px;">
                                            
                                                <div>Product Name:</div> 
                                                <b-form-input required v-model="special_product.product_name" size="sm" autocomplete="off"></b-form-input>
                                            
                                        </div>

                                        <div style="display: inline-block; width: 200px;">
                                            
                                                <div>SKU:</div> 
                                                <b-form-input required v-model="special_product.sku" size="sm" autocomplete="off"></b-form-input>
                                            
                                        </div>

                                        <div style="display: inline-block; width: auto; margin-right: 5px;">
                                            
                                                <div>Vendor:</div> 
                                           

                                                <!-- <b-form-input required v-model="special_product.vendor" size="sm"></b-form-input> -->

                                                <b-form-select
                                                    v-model="special_product.vendor_id"
                                                    :options="vendors"
                                                    size="sm"
                                                    variant="outline-primary"
                                                    style="width: 200px;"
                                                ></b-form-select>
                                                <span v-if="special_product.vendor_id == -1">
                                                    <input v-model="special_product.vendor" autocomplete="off"></input>
                                                </span>
                                            
                                        </div>

                                        <div style="display: inline-block; width: auto; margin-right: 5px;">
                                                <div>Category:</div> 
                                                <b-form-select
                                                    v-model="special_product.category_id"
                                                    :options="categories"
                                                    size="sm"
                                                    variant="outline-primary"
                                                    style="width: 200px;"
                                                ></b-form-select>
                                        </div>

                                        <b-button type="submit" variant="primary" size="sm">Add</b-button>
                                        <b-button variant="secondary" size="sm" @click="special_product={};">Clear</b-button>
                                    </b-form>
                                </div>

                            </div>

                        </div>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "RequestItems",
        props: ["showbacker"],
        components: {Backer, VueGoodTable, Multiselect},
        data: function(){
            return {
                ts: Requestor.moment(),
                userDetails: {},
                location_id: null,
                sublocation_id: null,
                locations: [],
                sublocations: [],
                vendors: [],
                vendorsdict: {},
                categories: [],
                categoriesdict: {},
                request_items: [],
                searched_products: [],
                searched_products_columns: [
                    {
                        label: "ID",
                        field: "product_id",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Name",
                        field: "product_name",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "SKU",
                        field: "product_sku",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Vendor",
                        field: "vendor",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Category",
                        field: "category",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                ],
                search_keyword: null,
                block_search: false,
                special_product: {},
                request_types: [
                    {value: "transfer_for_display", text: "Store Transfer (for display)"},
                    //{value: "transfer_for_pickup", text: "Store Transfer (for store customer pickup)"},
                    {value: "transfer_for_storage", text: "Store Transfer (for storage)"},
                    //{value: "transfer_for_delivery", text: "Customer Transfer (for customer delivery)"}
                ],
                submit_tr_enabled: true,
                c1: null
            }
        },
        methods: {
            onSearchedProductsColumnClick: function(params){
                let action = params.event.target.innerText;
                if (action === "Add") {
                    this.addRow(params.row);
                }
            },
            addRow: function(row){
                let item = JSON.parse(JSON.stringify(row));
                
                this.request_items.push({item: item, quantity: 0});
                return
            },
            searchProducts: function(e){
                if (e){
                    e.preventDefault();
                }
                if (!this.search_keyword || this.search_keyword.length < 2){
                    this.$bvToast.toast(
                        "Please search with a more specific keyword", 
                        {title: "Incomplete Search", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                let that = this;
                let path = "/api/product/search_product_v2/"
                let data = {keyword: this.search_keyword}

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else{

                        that.searched_products = response.data.result;
                        if (that.searched_products.length == 0){
                            that.$bvToast.toast(
                                "No products found matching keyword: '"+that.search_keyword+"'", 
                                {title: "No result", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                    that.block_search=false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.block_search=false;
                }
                this.block_search = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            reset_request: function(){
                this.request_items = [];
                // this.get_tr_id();
            },
            initAddItems: function(e){
                if (e){
                    e.preventDefault();
                }

                this.searched_products = [];
                this.search_keyword = null;
                this.init_add_items = true;
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, short: d.description}
                                });

                                if (that.userDetails.userrole == "storeadmin"){
                                    let location_id = that.userDetails.properties['location_id'];
                                    that.locations =  that.locations.filter(function(d){return d.value == location_id});
                                }
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/vendor/all2/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.vendors = response.data.result.map(function(d){
                                    return {value: d.id, text: d.vendor}
                                });
                                that.vendors.push(
                                    {value: -1, text: "CUSTOM VENDOR"}
                                )
                                that.vendorsdict = that.vendors.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading vendors list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/category/all2/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.categories = response.data.result.map(function(d){
                                    return {value: d.id, text: d.category}
                                });
                                that.categoriesdict = that.categories.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading categories list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            removeItem: function(idx){
                this.request_items.splice(idx, 1);
            },
            addSpecialProduct: function(e){
                if (e){
                    e.preventDefault();
                }

                if (this.special_product.vendor_id == -1){
                    if (!this.special_product.vendor){
                        this.$bvToast.toast(
                            "Please specify a vendor for the special product.", 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        return
                    }
                }
                else{
                    this.special_product.vendor = this.vendorsdict[this.special_product.vendor_id];
                }

                this.special_product.category = this.categoriesdict[this.special_product.category_id]

                let item = {
                    product_id: -1,
                    product_name: this.special_product.product_name,
                    product_sku: this.special_product.sku,
                    vendor: this.special_product.vendor,
                    category: this.special_product.category,
                }
                this.addRow(item);
                this.special_product = {};
            },
            validate_items: function(request_items){
                let errors = [];
                for (var i = 0; i<request_items.length; i++) {
                    let current_item = request_items[i].item;
                    let quantity = request_items[i].quantity;

                    if (!current_item.product_sku || (current_item.product_sku || '').length <= 1 ){
                        errors.push("One or more items missing SKU.");
                    }

                    if (!(quantity) || quantity == "" || isNaN(parseInt(quantity)) == true  || parseInt(quantity) <= 0){
                        errors.push("Please mention numeric quantity (> 0) for all items");
                    }

                    if (!(current_item.request_type) || current_item.request_type == ""){
                        errors.push("Please specify request types for all items.");
                    }

                    if (current_item.request_type == "transfer_for_pickup"){
                        if (!current_item.invoice_id || (current_item.invoice_id || "").length <= 1 ) {
                            errors.push("All transfer reequests of customer pickup type should include order's invoice id.")                            
                        }

                        if (!current_item.pickup_date || (current_item.pickup_date || "").length <= 1 ){
                            errors.push("All transfer reequests of customer pickup type should include expected pickup date.") 
                        }
                    }

                    if (current_item.request_type == "transfer_for_delivery"){
                        if (!current_item.invoice_id || (current_item.invoice_id || "").length <= 1 ) {
                            errors.push("All transfer reequests of customer delivery type should include order's invoice id.")                            
                        }

                        if (!current_item.delivery_date || (current_item.delivery_date || "").length <= 1 ){
                            errors.push("All transfer reequests of customer delivery type should include expected delivery date.") 
                        }

                        if (!current_item.custom_address || (current_item.custom_address || "").length <= 1 ){
                            errors.push("All transfer reequests of customer delivery type should include customer address for delivery.") 
                        }
                    }
                }
                return errors;
            },
            submitTR: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.location_id){
                    this.$bvToast.toast(
                        "Please select a requesting location.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                if (!this.sublocation_id){
                    this.$bvToast.toast(
                        "Please select a requesting sublocation.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                if (this.request_items.length <=0){
                    this.$bvToast.toast(
                        "No items to request.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                let items_error = this.validate_items(this.request_items);
                if (items_error.length > 0){
                    this.$bvToast.toast(
                        items_error[0], 
                        {title: "Error", autoHideDelay: 2500, variant:"danger"}
                    );
                    return
                }

                let that = this;
                let tr = {
                    location_id: this.location_id,
                    sublocation_id: this.sublocation_id,
                    requesting_user: this.userDetails.username,
                    items: this.request_items.map(function(d){
                        return {
                            quantity: parseInt(d.quantity),
                            product_id: d.item.product_id,
                            product_sku: d.item.product_sku,
                            request_type: d.item.request_type,
                            invoice_id: d.item.invoice_id,
                            vendor: d.item.vendor,
                            category: d.item.category,
                            pickup_date: d.item.pickup_date,
                            request_date: d.item.request_date, 
                        }
                    }),
                }
                console.log(tr);
                //return

                let path = "/api/inventory/submit_new_transfer_request/"
                let data = tr;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Transfer request submitted.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        //that.$router.push({path: "/inventory_products/trs/"});
                        location.reload();
                    }
                    that.submit_tr_enabled = true;
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.submit_tr_enabled = true;
                }
                this.submit_tr_enabled = false;
                Requestor.postSyncP(path, data, that, s, f);                
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                // if (this.userDetails.userrole == "admin" || this.userDetails.userrole == "storeadmin"){
                //     this.fetch_prereqs();
                // }
                // else {
                //     this.$router.replace({"path":  "/"})
                // }
                this.fetch_prereqs()
            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14px;
        background: #e5ffb1;
    }

    .tr_div {
        background: #efefef;
        border: 1px solid;
        margin-bottom: 37px;
    }
</style>


// WEBPACK FOOTER //
// src/components/RequestItems.vue